import { Dropdown } from "primereact/dropdown";
import { useResponsive } from "../../../responsive/ResponsiveProvider";
import { useAuthExperience } from "../../auth/hooks/useAuthExperience";

type PublicRoleSelectorProps = {
  selectedRole: string | null;
  onChange: (role: string | null) => void;
  title?: string;
  description?: string;
  compact?: boolean;
  inline?: boolean;
};

const PublicRoleSelector = ({
  selectedRole,
  onChange,
  title = "Choose Your Role",
  description = "Select your primary role.",
  compact = false,
  inline = false,
}: PublicRoleSelectorProps) => {
  const mobile = useResponsive().isMobile;
  const authExperience = useAuthExperience();
  const roleOptions = authExperience.roleOptions || [];
  const selectedRoleOption = roleOptions.find((role) => role.value === selectedRole);
  const useInlineLayout = inline && !mobile;

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div
        style={{
          width: "100%",
          maxWidth: "760px",
          background: "linear-gradient(135deg, #fff7ed 0%, #ffffff 45%, #eff6ff 100%)",
          border: "2px solid #fdba74",
          borderRadius: mobile ? "18px" : "20px",
          padding: compact
            ? (mobile ? "0.8rem 0.9rem" : "0.95rem 1.1rem")
            : (mobile ? "1rem" : "1.2rem 1.3rem"),
          boxShadow: "0 20px 44px rgba(227, 139, 44, 0.14)",
        }}
      >
        {useInlineLayout ? (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1rem" }}>
            <div style={{ fontWeight: 700, color: "#0f3d63", fontSize: "0.98rem", whiteSpace: "nowrap" }}>{title}</div>
            <Dropdown
              value={selectedRole}
              options={roleOptions}
              optionLabel="label"
              optionValue="value"
              placeholder="Select a role"
              showClear
              style={{ width: "100%", maxWidth: "320px" }}
              onChange={(event) => onChange(event.value || null)}
            />
          </div>
        ) : (
          <>
        <div style={{ textAlign: "center", fontWeight: 700, color: "#0f3d63", marginBottom: compact ? "0.15rem" : "0.35rem", fontSize: mobile ? "1rem" : (compact ? "1.02rem" : "1.1rem") }}>{title}</div>
        <div style={{ color: "#5f7488", lineHeight: compact ? 1.45 : 1.7, marginBottom: compact ? "0.65rem" : "0.95rem", textAlign: "center", fontSize: mobile ? "0.9rem" : (compact ? "0.94rem" : "1rem") }}>{description}</div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Dropdown
            value={selectedRole}
            options={roleOptions}
            optionLabel="label"
            optionValue="value"
            placeholder="Select a role"
            showClear
            style={{ width: "100%", maxWidth: mobile ? "100%" : (compact ? "340px" : "360px") }}
            onChange={(event) => onChange(event.value || null)}
          />
        </div>
          </>
        )}
        {selectedRoleOption?.description ? (
          <div
            className="mt-3 p-3 border-round"
            role="status"
            style={{ background: "#eff6ff", border: "1px solid #bfdbfe", color: "#1e3a5f", lineHeight: 1.5 }}
          >
            <div style={{ fontWeight: 700 }}>As a {selectedRoleOption.label}, you can:</div>
            <div className="mt-1">{selectedRoleOption.description}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PublicRoleSelector;
